export default __webpack_public_path__ + "static/media/SEO.799cef62.png";